// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global BackgroundCheck */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Toggle header background color on scroll
         */
        __toggleHeaderBackground: () => {
            let scrollTimeout = null;
            const throttle = 50;

            toggleHeaderBackgroundClass();

            // Simple scroll throttle
            $(window).on('scroll', function() {
                if(!scrollTimeout) {
                    scrollTimeout = setTimeout(function() {
                        toggleHeaderBackgroundClass();
                        scrollTimeout = null;
                    }, throttle);
                }
            });

            function toggleHeaderBackgroundClass() {
                const scroll_length = 30;
                const scroll = $(window).scrollTop();

                if(scroll >= scroll_length) {
                    wntrTheme.body.find('header').addClass('header--solid');
                } else {
                    wntrTheme.body.find('header').removeClass('header--solid');
                }
            }
        },

        /**
         * Smooth scroll to anchors
         */
        __smoothScrollToAnchors: () => {
          $('.home .menu-item-object-custom a').on('click', function(e) {
            e.preventDefault();

            const id = $(this).attr('href').substring($(this).attr('href').indexOf('#')+1);

            $('html, body').animate({
              scrollTop: wntrTheme.body.find('#' + id).offset().top
            }, 500);
          });
        },

        /**
         * Background check text agains images
         */
        __bakgroundCheck: () => {
            // Specific images
            BackgroundCheck.init({
                targets: '.header__social',
            });
        },

        /**
         * Add number of column class to wp-column block
         */
        __addNumColumnClass: function() {
            const $columns = wntrTheme.body.find('.wp-block-columns');
            if($columns.length > 0) {
                $.each($columns, function() {
                    const $el = $(this);
                    $el.addClass('wp-block-columns--' + $el.find('.wp-block-column').length);
                });
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);